// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"116366c9","241":"6624a139","662":"aa68e603","836":"ed1d9a25","971":"5c841492"}[chunkId] + ".chunk.js";
};